export default __webpack_public_path__ + "static/media/youtube-logo-transparent-white.5bd921e0.png";